const isValid = (email: string) => /.+@.+\..+/.test(email) || 'E-mail deve ser válido';
const isRequired = (email: string) => !!email || 'Informe seu e-mail';

export default [isRequired, isValid];
